// extracted by mini-css-extract-plugin
export default {"template":"RequestTemplatePopupInfo_template__GmaMa","rule":"RequestTemplatePopupInfo_rule__BIJ5w"};